import { Component } from 'react';
import { withRouter } from 'react-router';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location
    && !(this.props.location.state && this.props.location.state.modal)
    && !(prevProps.location.state && prevProps.location.state.modal)
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/modules/common/components/app/ScrollToTop.js